import $ from "../core/jquery-global";

export function initScrollTop() {
    $(document).on("click", ".js_scrollTop", function () {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: 0
            },
            800
        );
    });
}
